module.exports = __webpack_public_path__ + "static/media/ic_bug.c6c09894.svg";